import { IconBase, IconComponent } from './BaseIcon';

export const Save: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M28.73 6.65l-4-4.33A1 1 0 0024 2H4a1 1 0 00-1 1v26a1 1 0 001 1h24a1 1 0 001-1V7.33a1 1 0 00-.27-.68zM9 4h14v6H9zm18 24H5V4h2v7a1 1 0 001 1h16a1 1 0 001-1V5.56l2 2.16zM15.92 14.1a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z" />
  </IconBase>
);
